<template>
  <v-app class="grey lighten-3" v-if="isLoggedIn">
      <div>
        <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        >
        {{ errorMsg }}
        <v-btn
        color="pink"
        flat
        @click="snackbar = false"
        >
        Close
        </v-btn>
        </v-snackbar>
      </div>
      
      <v-toolbar flat color="white">
        <v-toolbar-title>Notification Message</v-toolbar-title>
      <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          align="center"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Create</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md12>
                    <v-text-field v-model="editedItem.title" box label="Title"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout wrap>
                  <v-flex xs12 sm6 md12>
                    <v-textarea v-model="editedItem.message" box label="Message"></v-textarea>
                  </v-flex>
                </v-layout>

                <v-layout wrap>
                  <v-flex xs12 sm6 md12>
                    <v-text-field 
                    v-model="editedItem.status" 
                    placeholder="digits between 0 or 1" 
                    type="number"
                    label="Active"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!-- <v-switch
                v-model="editedItem.status"
                :input-value="editedItem.status"
                label="Active Status"
                @change="editedItem.status = $event"
                ></v-switch> -->
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="indexData.notifyMsg"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.id }}</td>
          <td class="text-xs-center">{{ props.item.created_by }}</td>
          <td class="text-xs-center">{{ props.item.title }}</td>
          <td class="text-xs-center">{{ props.item.message }}</td>
          <td class="text-xs-center">{{ props.item.status }}</td>
          <td class="justify-center layout px-0">
            <v-icon
              small
              class="mr-2"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <!-- <v-icon
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon> -->
          </td>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
  </v-app>
  <v-layout v-else>
    <Signin class="mt-1"></Signin>
  </v-layout>
</template>
<script>
import {mapGetters} from 'vuex'
import Signin from "../../views/auth/Signin";

 export default {
    components: {
      Signin,
    },
    data: () => ({
      dialog: false,
      search: '',
      apiUrl: 'notify-message',
      snackbar: false,
      y: 'top',
      x: 'right',
      timeout: 4000,
      headers: [
        {
          text: 'ID',
          align: 'center',
          sortable: false,
          value: 'id'
        },
        {
          text: 'Created By',
          align: 'center',
          sortable: false,
          value: 'created_by'
        },
        {
          text: 'Message Title',
          align: 'center',
          sortable: false,
          value: 'title'
        },
        {
          text: 'Notification Message',
          align: 'center',
          sortable: false,
          value: 'message'
        },
        {
          text: 'Active Status',
          align: 'center',
          sortable: false,
          value: 'status'
        },
        { text: 'Actions', align:'center',value: 'actions' },
      ],
      editedIndex: -1,
      editedItem: {
        id:'',
        title:'',
        message:'',
        status:''
      },
      defaultItem: {
        id:'',
        title:'',
        message:'',
        status:''
      }
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg']),
      formTitle () {
        return this.editedIndex === -1 ? 'Crete New' : 'Edit'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.$store.dispatch('setIndexData', [this.apiUrl])
      },

      setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      editItem (item) {
        this.editedIndex = this.indexData.notifyMsg.indexOf(item)
        // this.editedItem = Object.assign({}, item)
        this.editedItem.id = item.id
        this.editedItem.title = item.title
        this.editedItem.message = item.message
        this.editedItem.status = item.status
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.indexData.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.indexData.splice(index, 1)
        this.$store.dispatch('delete', [this.apiUrl, item.id])
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        //   console.log(this.editedItem)
        if (this.editedIndex > -1) {
          this.$store.dispatch('storeOrUpdate', [this.apiUrl, this.editedItem])
        } else {
          this.$store.dispatch('storeOrUpdate', [this.apiUrl, this.editedItem])
        }
        this.snackbar=true
        this.close()
        // this.initialize()
      }
    }
  }
</script>